import { observer } from 'mobx-react-lite'
import React from 'react'
import { Divider, EnumSpinnerLoaderPosition, FullPageWrapper, SpinnerLoader } from 'shared/ui'
import { ContactsDetails } from 'widgets/ContactsDetails'
import { usePowerDialerViewContext } from 'pages/powerDialer/pages/view/context/powerDialerViewContext'
import { PowerDialerContactsFilter } from 'pages/powerDialer/pages/view/ui/PowerDialerContacts/PowerDialerContactsFilter/PowerDialerContactsFilter'
import { PowerDialerContactsSearch } from 'pages/powerDialer/pages/view/ui/PowerDialerContacts/PowerDialerContactsSearch/PowerDialerContactsSearch'
import { PowerDialerContactsTable } from 'pages/powerDialer/pages/view/ui/PowerDialerContacts/PowerDialerContactsTable/PowerDialerContactsTable'

export const PowerDialerContacts = observer(() => {
  const { powerDialerContactsStore } = usePowerDialerViewContext()

  if (!powerDialerContactsStore)
    return (
      <SpinnerLoader
        ariaLabel={'PowerDialerContacts'}
        position={EnumSpinnerLoaderPosition.Absolute}
      />
    )

  const { contactsDetailsStore } = powerDialerContactsStore

  return (
    <>
      <FullPageWrapper>
        <PowerDialerContactsFilter />
        <Divider sx={{ marginLeft: '20px', marginTop: '15px', marginBottom: '15px' }} />
        <PowerDialerContactsSearch />
        <PowerDialerContactsTable powerDialerContactsStore={powerDialerContactsStore} />
      </FullPageWrapper>

      {contactsDetailsStore && <ContactsDetails store={contactsDetailsStore} />}
    </>
  )
})
